import { useQuery } from 'react-query';

import { getOrganization } from '@services/queries/organization';
import { getProfile } from '@services/queries/profile';
import { getStudioNumbers } from '@services/queries/studios';

import { updateBeamUrl } from '@utils';
import LogoImage from '@assets/png/default-studio.png';
import { Container, Logo } from './StudioNumbers.styles';

interface IStudioNumbersContent {
  picture?: string;
  // equipments: number | null;
}

const StudioNumbersContent = ({
  // equipments,
  picture,
}: IStudioNumbersContent) => {
  return (
    <Container>
      <Logo src={picture || LogoImage} alt="logo" />
    </Container>
  );
};

const StudioNumbers = () => {
  const orgQuery = useQuery('organization', getOrganization);
  const numbersQuery = useQuery('studioNumbers', async () => {
    const profile = await getProfile();
    const numbers = await getStudioNumbers(profile.userGroup.studioId);

    return numbers;
  });
  if (orgQuery.isLoading || numbersQuery.isLoading) {
    return <StudioNumbersContent />;
  }

  if (orgQuery.isError || numbersQuery.isError) {
    return <StudioNumbersContent />;
  }
  if (orgQuery.data?.metadata && orgQuery.data.metadata instanceof String) {
    return (
      <StudioNumbersContent
        picture={updateBeamUrl(orgQuery.data.metadata as string)}
      />
    );
  }

  if (orgQuery.data?.logo) {
    return <StudioNumbersContent picture={updateBeamUrl(orgQuery.data.logo)} />;
  }

  return <StudioNumbersContent />;
};

export { StudioNumbers };
